import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { format } from "date-fns";
import EmployeeNavbar from "../Layout/EmployeeNavbar";
import API_BASE_URL from "../config";

const EmployeeHolidayPage = () => {
    const currentDate = new Date();
    const [holidays, setHolidays] = useState([]);
    const [month, setMonth] = useState(currentDate.getMonth() + 1); // 1–12
    const [year, setYear] = useState(currentDate.getFullYear());
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const token = localStorage.getItem("token");

    // Fetch holidays when month/year changes
    useEffect(() => {
        fetchHolidays(year, month);
    }, [month, year]);

    // 🔐 Authentication check
  useEffect(() => {
    const token = localStorage.getItem("token"); // or localStorage
    if (!token) {
      toast.error("You must be logged in to access this page.");
      navigate("/");
    }
  }, [navigate]);

    // 🟢 Fetch and filter holidays
    const fetchHolidays = async (y, m) => {
  try {
    setLoading(true);
    setError("");

    const res = await axios.get(
      `${API_BASE_URL}/api/holidays`,
      {
        headers: {
          Authorization: `Bearer ${token}`, 
        },
      }
    );

    let allHolidays = res.data || [];

    // Filter by year
    allHolidays = allHolidays.filter((h) => {
      const start = new Date(h.startDate);
      return start.getFullYear() === y;
    });

    // If month is not "0" (All Months)
    if (m !== 0) {
      allHolidays = allHolidays.filter((h) => {
        const start = new Date(h.startDate);
        return start.getMonth() + 1 === m;
      });
    }

    setHolidays(allHolidays);
  } catch (err) {
    console.error("❌ Failed to fetch holidays:", err);
    setError("Failed to fetch holidays. Please try again.");
  } finally {
    setLoading(false);
  }
};


    const handleMonthChange = (e) => setMonth(parseInt(e.target.value));
    const handleYearChange = (e) => setYear(parseInt(e.target.value));

    const monthNames = [
        "All Months",
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December",
    ];

    return (
        <>
           <div className="fixed-top">
        <EmployeeNavbar />
      </div>
                <div className="container-fluid mt-5" style={{ paddingTop: "80px" }}>
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h4 className="fw-bold text-dark mb-0"> Holiday Calendar</h4>

                    <div className="d-flex gap-3 align-items-center">
                        <select
                            className="form-select form-select-sm w-auto"
                            value={month}
                            onChange={handleMonthChange}
                        >
                            {monthNames.map((m, i) => (
                                <option key={i} value={i === 0 ? 0 : i}>
                                    {m}
                                </option>
                            ))}
                        </select>

                        <select
                            className="form-select form-select-sm w-auto"
                            value={year}
                            onChange={handleYearChange}
                        >
                            {Array.from({ length: 5 }, (_, i) => year - 2 + i).map((y) => (
                                <option key={y} value={y}>
                                    {y}
                                </option>
                            ))}
                        </select>

                        <button
                            className="btn btn-primary btn-sm"
                            onClick={() => fetchHolidays(year, month)}
                        >
                            Refresh
                        </button>
                    </div>
                </div>

                <div
                    className="bg-white shadow-none rounded-3 p-3"
                    style={{ height: "calc(100vh - 140px)", overflowY: "auto" }}
                >
                    {loading ? (
                        <p>Loading holidays...</p>
                    ) : error ? (
                        <p className="text-danger">{error}</p>
                    ) : holidays.length === 0 ? (
                        <p className="text-muted">No holidays found for this selection.</p>
                    ) : (
                        <div className="table-responsive" style={{ height: "75vh", overflowY: "auto" }} >
                            <table className="table table-bordered align-middle text-start" >
                                <thead className="table position-sticky top-0">
                                    <tr>
                                        <th style={{ width: "60px",backgroundColor: "#DFE4EB"  }}>Sr</th>
                                        <th style={{ minWidth: "180px",backgroundColor: "#DFE4EB" }}>Holiday Name</th>
                                        <th style={{ minWidth: "160px",backgroundColor: "#DFE4EB" }}>Start Date</th>
                                        <th style={{ minWidth: "160px" ,backgroundColor: "#DFE4EB"}}>End Date</th>
                                        <th style={{ minWidth: "100px" ,backgroundColor: "#DFE4EB"}}>Type</th>
                                        <th style={{ backgroundColor: "#DFE4EB"}}>Description</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {holidays.map((h, i) => {
                                        const start = new Date(h.startDate);
                                        const end = h.endDate ? new Date(h.endDate) : null;

                                        const startStr = !isNaN(start)
                                            ? format(start, "dd-MMM-yyyy (EEE)")
                                            : "—";

                                        const endStr =
                                            end && !isNaN(end)
                                                ? format(end, "dd-MMM-yyyy (EEE)")
                                                : "—";

                                        return (
                                            <tr key={i}>
                                                <td>{i + 1}</td>
                                                <td className="fw-semibold">{h.name || "—"}</td>
                                                <td >{startStr}</td>
                                                <td>{endStr}</td>
                                                <td>
                                                    <span
                                                        className={`badge ${h.type?.toUpperCase() === "PUBLIC"
                                                            ? "bg-success"
                                                            : h.type?.toUpperCase() === "OPTIONAL"
                                                                ? "bg-warning text-dark"
                                                                : "bg-secondary"
                                                            }`}
                                                    >
                                                        {h.type || "N/A"}
                                                    </span>
                                                </td>
                                                <td>{h.description || "—"}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default EmployeeHolidayPage;
